import { Component, OnInit } from '@angular/core';
import { NewsService } from '../services/news.service';
import { MoviesService } from '../services/movies.service';
import * as $ from 'jquery';
@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  lastNews ; playingMovies ; getMovies:any[] 
  constructor(private  newsdata:NewsService , private myMovie:MoviesService) 
  {
    this.playingMovies = this.myMovie.movies;
    this.lastNews = this.newsdata.newsData ;
    

    
   }

  ngOnInit() {

    $(document).ready(function(){

      $(".con-playing-movies:first").addClass("act");

      /*********************************** */
    
      /***************************************** */
  

    });
  }
  showImage(staus:string)
  {
    var allImages = document.getElementsByClassName("con-playing-movies"); 
    
    
    for(let i = 0 ; i < allImages.length ; i++)
    {
     
      if(allImages[i].classList.contains("act"))
      {
       
        allImages[i].classList.remove("act")
        var y = i+1   ;
        if(staus === 'next')
        {   
          
            if(y <allImages.length ){
            allImages[y].classList.add("act") 
            break
            }
            else
            {
              y = 0 ; 
              allImages[y].classList.add("act")
              break
            }
          
        }
        else
        {
          y = i - 1  ; 
         
          if(y <0 ){
            
            y = allImages.length -1 ; 
              allImages[y].classList.add("act")
              break
            }
            else
            {
              allImages[y].classList.add("act")
              break
            }
        }

      }
    }
  }

}
